import isClick from '../../assets/scripts/utils/click';
import { slideUp, slideDown } from '../../assets/scripts/utils/slide';
const collapseAll = (parentEl) => {
    if (!parentEl)
        return;
    const speed = 400;
    parentEl.querySelectorAll('[data-collapse]').forEach((toggle) => {
        var _a;
        const collapse = document.querySelector((_a = toggle.getAttribute('data-collapse')) !== null && _a !== void 0 ? _a : '');
        if (collapse === null || collapse === void 0 ? void 0 : collapse.classList.contains('show')) {
            collapse.classList.add('is-collapsing');
            toggle.setAttribute('aria-expanded', 'false');
            slideUp(collapse, speed, () => {
                collapse.classList.remove('is-collapsing');
                collapse.classList.remove('show');
            });
        }
    });
};
const handleCollapseToggleClick = (event) => {
    var _a, _b;
    const speed = 400;
    const toggle = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('[data-collapse]');
    if (toggle) {
        const typeAttr = toggle.getAttribute('type') || '';
        const isChecked = (isClick(event) === true);
        if (isChecked) {
            if ((typeAttr !== 'checkbox') && (typeAttr !== 'radio')) {
                event.preventDefault();
            }
            const collapse = document.querySelector((_b = toggle.getAttribute('data-collapse')) !== null && _b !== void 0 ? _b : '');
            if (collapse && !collapse.classList.contains('is-collapsing')) {
                if (collapse.classList.contains('show')) {
                    collapse.classList.add('is-collapsing');
                    toggle.setAttribute('aria-expanded', 'false');
                    slideUp(collapse, speed, () => {
                        collapse.classList.remove('is-collapsing');
                        collapse.classList.remove('show');
                    });
                }
                else {
                    const parentSelector = collapse.getAttribute('data-parent') || '';
                    if (parentSelector) {
                        const parent = document.querySelector(parentSelector);
                        if (parent) {
                            collapseAll(parent);
                        }
                    }
                    collapse.classList.add('is-collapsing');
                    toggle.setAttribute('aria-expanded', 'true');
                    slideDown(collapse, speed, () => {
                        collapse.classList.remove('is-collapsing');
                        collapse.classList.add('show');
                    });
                }
            }
        }
    }
};
export const initCollapse = () => {
    document.addEventListener('click', handleCollapseToggleClick);
    document.addEventListener('keypress', handleCollapseToggleClick);
};
initCollapse();
